/**
 * „Logbuch des Käpt'ns" (F5, Batch 0.14.0) — Landing-Client. Liest das
 * gerätelokale Gast-Aggregat aus `localStorage['tw.log']`, füllt die SSR-Sektion
 * `.captain-log` (Zahlen-Slots) und unhidet sie NUR, wenn schon mindestens ein
 * Match gespielt wurde (`played > 0`).
 *
 * Rein clientseitig — KEIN Three.js, kein Netzwerk, kein Analytics-Beacon
 * (gerätelokal, nie zum Server). try/catch-defensiv (Safari Private Mode);
 * korrupte Werte werden als „kein Logbuch" behandelt (Sektion bleibt versteckt).
 */

interface CaptainLog {
  played: number;
  won: number;
  bestWave: number;
}

/** Nicht-negative Ganzzahl oder 0 (defensiv gegen korrupte/fremde Werte). */
function saneCount(v: unknown): number {
  return typeof v === 'number' && Number.isFinite(v) && v >= 0 ? Math.floor(v) : 0;
}

function readLog(): CaptainLog | null {
  try {
    const raw = localStorage.getItem('tw.log');
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<CaptainLog>;
    const played = saneCount(parsed.played);
    if (played <= 0) return null; // truth-conditional: ohne gespieltes Match kein Logbuch
    return { played, won: saneCount(parsed.won), bestWave: saneCount(parsed.bestWave) };
  } catch {
    return null;
  }
}

function fillSlot(root: Element, key: string, value: number): void {
  const el = root.querySelector<HTMLElement>(`[data-log="${key}"]`);
  if (el) el.textContent = String(value);
}

function render(): void {
  const section = document.querySelector('.captain-log');
  if (!section) return;
  const log = readLog();
  if (!log) return; // played === 0 / kein/korruptes Logbuch → Sektion bleibt hidden
  fillSlot(section, 'played', log.played);
  fillSlot(section, 'won', log.won);
  fillSlot(section, 'bestWave', log.bestWave);
  section.removeAttribute('hidden');
}

render();
